
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { AuthFormValues } from "@/schemas/authSchema";
import { MobilePasswordField } from "./MobilePasswordField";

interface MobileAuthFormFieldsProps {
  mode: "signin" | "signup";
  showPassword: boolean;
  onTogglePassword: () => void;
  onForgotPassword: () => void;
  register: UseFormRegister<AuthFormValues>;
  errors: FieldErrors<AuthFormValues>;
  isLoading: boolean;
}

export function MobileAuthFormFields({
  mode,
  showPassword,
  onTogglePassword,
  onForgotPassword,
  register,
  errors,
  isLoading,
}: MobileAuthFormFieldsProps) {
  return (
    <div className="space-y-4">
      {mode === "signup" && (
        <div className="space-y-2">
          <Label htmlFor="name">Name</Label>
          <Input
            id="name"
            type="text"
            placeholder="Your name"
            className="mobile-form-input"
            autoComplete="name"
            {...register("name")}
          />
          {errors.name && (
            <p className="text-sm text-destructive">
              {errors.name.message}
            </p>
          )}
        </div>
      )}

      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          placeholder="you@example.com"
          className="mobile-form-input"
          autoComplete="email"
          {...register("email")}
        />
        {errors.email && (
          <p className="text-sm text-destructive">
            {errors.email.message}
          </p>
        )}
      </div>

      <MobilePasswordField
        mode={mode}
        showPassword={showPassword}
        onTogglePassword={onTogglePassword}
        onForgotPassword={onForgotPassword}
        register={register}
        errors={errors}
      />

      <Button
        type="submit"
        disabled={isLoading}
        className="mobile-button"
      >
        {isLoading
          ? mode === "signup"
            ? "Creating account..."
            : "Signing in..."
          : mode === "signup"
          ? "Create account"
          : "Sign in"
        }
      </Button>
    </div>
  );
}
